import React from "react";
import { Redirect, useParams } from "react-router-dom";
import PropTypes from "prop-types";

import { isEmail } from "validator";

import { useVerifyCodeForm } from "scenes/Authentication/hooks";

import {
  Button,
  Form,
  Layout,
  VerifyCodeInfoMessage,
  VerifyCodeInput,
} from "./components";

export function VerificationCodeForm({ email }) {
  const { formProps, confirmSignUp, resendCode, loading, error } =
    useVerifyCodeForm({ email });

  if (!email) return null;

  return (
    <Layout
      errorMessage={error}
      infoMessage={<VerifyCodeInfoMessage email={email} />}
    >
      <Form {...formProps} onSubmit={confirmSignUp}>
        <div style={{ marginTop: "22px" }}>
          <VerifyCodeInput disabled={loading} onResendCode={resendCode} />
        </div>
        <Button
          primary
          fluid
          loading={loading}
          disabled={loading}
          style={{ marginTop: "22px" }}
        >
          Confirm Verification Code
        </Button>
      </Form>
    </Layout>
  );
}

VerificationCodeForm.propTypes = { email: PropTypes.string };

VerificationCodeForm.defaultProps = { email: "" };

export default function VerificationCodeFormWithRouter() {
  const { email } = useParams();

  if (!email || !isEmail(email)) return <Redirect to="/v2/login" />;

  return <VerificationCodeForm email={email} />;
}
